import { Box, Skeleton, Stack, Table, TableBody, TableCell, TableRow, Typography, useTheme } from "@mui/material";
import { EkpTableProps, RowData } from "src/components/tables/ekp-table/commonTypes";
import { SenecEkpTheme } from "src/styles/ekp-theme/senecEkpTheme";
import { styled } from "src/styles/ekp-theme/ekpStyled";
import { FlyingCat } from "src/components/tables/ekp-table/FlyingCat";

export const EkpTableDesktop = ({ noDataText, rows, filteredRows, loading, handleRowClick }: EkpTableProps) => {
    const theme: SenecEkpTheme = useTheme();

    return (
        <Table aria-label="desktop-table">
            <TableBody data-testid="body">
                {loading ? (
                    <DesktopLoadingRows />
                ) : (
                    <>
                        {/*ROWS */}
                        {filteredRows?.map((filteredRow, idx) => (
                            <StyledTableRow
                                hover={true}
                                key={idx}
                                data-testid="desktop-row"
                                onClick={() => handleRowClick && rows != null && handleRowClick(rows[idx])}
                            >
                                {/* CELLS */}
                                {Object.entries(filteredRow as RowData).map((entry, id) => (
                                    <TableCell key={id}>
                                        <Stack
                                            alignItems={id === Object.keys(filteredRow).length - 1 ? "end" : "start"}
                                            sx={{ minHeight: "24px", maxHeight: "48px" }}
                                        >
                                            <Typography
                                                variant={id == 0 ? "h4" : "body1Responsive"}
                                                color={
                                                    id == 0
                                                        ? theme.palette.senecPrimary.nightDarkGrey
                                                        : theme.palette.senecSecondary.neutralGray70
                                                }
                                            >
                                                {entry[1].label ? entry[1].label : entry[1].value}
                                            </Typography>
                                        </Stack>
                                    </TableCell>
                                ))}
                            </StyledTableRow>
                        ))}
                        {/*EMPTY ROWS */}
                        {(!filteredRows || filteredRows.length === 0) && (
                            <Box p={2} m={"auto"} width={"fit-content"}>
                                <Box width={"fit-content"} margin={"auto"}>
                                    <FlyingCat />
                                </Box>
                                <Box pt={3} maxWidth={"411px"}>
                                    <Typography variant={"h4"} align={"center"}>
                                        {noDataText}
                                    </Typography>
                                </Box>
                            </Box>
                        )}
                    </>
                )}
            </TableBody>
        </Table>
    );
};

const DesktopLoadingRows = ({ columnCount = 4, maxLoadingRows = 4 }: { columnCount?: number; maxLoadingRows?: number }) => {
    return (
        <>
            {Array(maxLoadingRows)
                .fill(0)
                .map((row, idx) => (
                    <StyledTableRow key={idx}>
                        {Array(columnCount)
                            .fill(0)
                            .map((num, i) => (
                                <TableCell key={i} width={i === 0 ? "55%" : "15%"}>
                                    <Typography>
                                        <Skeleton data-testid="desktop-skeleton" width={i === 0 ? "75%" : "100%"} />
                                    </Typography>
                                </TableCell>
                            ))}
                    </StyledTableRow>
                ))}
        </>
    );
};

const StyledTableRow = styled(TableRow)(({ theme }: { theme: SenecEkpTheme }) => ({
    "&:hover": {
        cursor: "pointer",
        backgroundColor: theme.palette.senecSecondary.neutralGray000 + " !important",
    },
    "& tr": {
        height: "auto",
    },
    "& td": {
        border: 0,
        height: "auto",
    },
    "& td:first-of-type": {
        borderRadius: "12px 0 0 12px",
    },
    "& td:last-child": {
        borderRadius: "0 12px 12px 0",
    },
}));
